export default {
	id: "blue",
	name: "Blue",
	colors: {
		"--theme-foreground": "#B0C4FF ",
		"--theme-foreground-muted": "#6A7699",
		"--theme-foreground-against-accent": "#FFF",
		"--theme-background": "#171A22",
		"--theme-background-muted": "#1C1F28",
		"--theme-border": "#3D4459",
		"--theme-border-muted": "#232733 ",
		"--theme-menu-foreground": "#FFF",
		"--theme-menu-background": "#0F141E",
		"--theme-good": "#65C05A",
		"--theme-bad": "#FF5763",
		"--theme-foreground-against-good": "#FFF",
		"--theme-foreground-against-bad": "#FFF",
	}
};
